import { render, staticRenderFns } from "./SelectCandidates.vue?vue&type=template&id=53e5b0cd&"
import script from "./SelectCandidates.vue?vue&type=script&lang=js&"
export * from "./SelectCandidates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports